import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';

import { AddUserToThisSessionButtonComponent } from './nav-bar/components/add-user-to-this-session/add-user-to-this-session-button.component';
import { AudioVideoConnectionMonitorModule } from 'src/app/features/audio-video-connection-monitor';
import { DuplicateSessionDetectorModule } from 'src/app/features/duplicate-session-detector';
import { FeatureManagementDirectiveModule } from 'src/app/features/feature-management/directives/feature-management-directive.module';
import { HelpFaqModule } from 'src/app/features/help-faq';
import { SupportPhoneNumberButtonComponent } from 'src/app/features/layout/nav-bar/components/support-phone-number/support-phone-number-button.component';
import { ModalsModule } from 'src/app/features/modals/modals.module';
import { PackageUsersModule } from 'src/app/features/package-users';
import { PackagesModule } from 'src/app/features/packages';
import { SharedModule } from 'src/app/features/shared';

import {
  CancelSigningModalComponent,
  ExitSigningConfirmationComponent,
  FeedbackLayoutComponent,
  FooterComponent,
  HeaderSlimComponent,
  IdVerifyComponent,
  InternetCheckComponent,
  OptOutModalComponent,
  PreSessionLayoutComponent,
  PreSignLayoutComponent,
  SideBarComponent,
  SigningDetailsComponent,
  SigningSessionLayoutComponent,
} from './';

import { AudioVideoCheckComponent } from '../av-check/components/audio-video-component-check/audio-video-check.component';
import { AudioVideoModalContainerComponent } from './components/audio-video-modal/audio-video-modal-container.component';
import { AudioVideoModalComponent } from './components/audio-video-modal/audio-video-modal.component';

import { ParticipantListFluidMaxHeightDirective } from './components/participant-list/participant-list-fluid-max-height/participant-list-fluid-max-height.directive';
import { ParticipantListTimerComponent } from './components/participant-list/participant-list-timer.component/participant-list-timer.component';
import { ParticipantListComponent } from './components/participant-list/participant-list.component';
import { SigningsMonthlyCardComponent } from './components/signings-monthly-card/signings-monthly-card.component';
import { NavBarPreSessionComponent } from './nav-bar-pre-session/nav-bar-pre-session.component';
import { NavBarPreSignComponent } from './nav-bar-pre-sign/nav-bar-pre-sign.component';
import { NavBarSessionEndingComponent } from './nav-bar-session-ending/nav-bar-session-ending.component';
import { NavBarSigningSessionComponent } from './nav-bar-signing-session/nav-bar-signing-session.component';
import { MenuComponent } from './nav-bar/components/menu/menu.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { PostSessionLayoutComponent } from './post-session-layout/post-session-layout.component';

@NgModule({
  declarations: [
    CancelSigningModalComponent,
    ExitSigningConfirmationComponent,
    FeedbackLayoutComponent,
    FooterComponent,
    HeaderSlimComponent,
    IdVerifyComponent,
    InternetCheckComponent,
    OptOutModalComponent,
    PreSessionLayoutComponent,
    PreSignLayoutComponent,
    SideBarComponent,
    SigningDetailsComponent,
    SigningSessionLayoutComponent,
    AudioVideoModalComponent,
    AudioVideoModalContainerComponent,
    NavBarPreSessionComponent,
    ParticipantListComponent,
    SigningsMonthlyCardComponent,
    ParticipantListFluidMaxHeightDirective,
    NavBarPreSignComponent,
    NavBarComponent,
    NavBarSigningSessionComponent,
    NavBarSessionEndingComponent,
    PostSessionLayoutComponent,
    AddUserToThisSessionButtonComponent,
    SupportPhoneNumberButtonComponent,
    MenuComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    FormsModule,
    ModalsModule,
    RouterModule.forChild([]),
    PackagesModule,
    PackageUsersModule,
    ReactiveFormsModule,
    AudioVideoCheckComponent,
    AudioVideoConnectionMonitorModule,
    DuplicateSessionDetectorModule,
    FeatureManagementDirectiveModule,
    HelpFaqModule,
    MatFormFieldModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    DuplicateSessionDetectorModule,
    MatProgressBarModule,
    ParticipantListTimerComponent,
  ],
  exports: [
    PreSessionLayoutComponent,
    PreSignLayoutComponent,
    SigningSessionLayoutComponent,
    FeedbackLayoutComponent,
    PostSessionLayoutComponent,
    ParticipantListComponent,
  ],
})
export class LayoutModule {}
